
export default [
  {
    title: 'React & Angular',
    description: 'Front-end development using React library and AngularJS framework',
    icons: ['FaHtml5', 'FaReact', 'FaAngular'],
    experience: 'over 1 year'
  },
  {
    title: 'CSS & Design',
    description: 'Front-end styling using Material Design and Bootstrap',
    icons: ['FaCss3Alt'],
    experience: 'over 1 year'
  },
  {
    title: 'JavaScript, Node.js & npm',
    description: 'Development of REST APIs using JWT authentication, creation of NPM modules, tests, among others',
    icons: ['DiJsBadge', 'FaNodeJs', 'FaNpm'],
    experience: 'over 1 year'
  },
  {
    title: 'Python',
    description: 'Desktop software development using wxPython library',
    icons: ['FaPython'],
    experience: 'over 2 years'
  },
  {
    title: 'C/C++',
    description: 'Research project in the optimization area.',
    icons: ['AiOutlineCode'],
    experience: 'over 2 years'
  },
  {
    title: 'Haskell',
    description: 'Development using Haskell concepts such as List comprehension, Pattern matching and Guards',
    icons: ['DiHaskell'],
    experience: ''
  },
  {
    title: 'Docker',
    description: 'Use of containers to host APIs, improving the way of delivering code',
    icons: ['FaDocker'],
    experience: 'over 1 year'
  }
];
